export default __webpack_public_path__ + "static/media/genderIcon.1ccf074b.png";